import { NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { StorybookModule } from '@app/storybook/storybook.module';
import { SharedModule } from '../sharedModule/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { PrintModule } from '@app/dashboard/print/print.module';

@NgModule({
  declarations: [DashboardComponent],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    StorybookModule,
    SharedModule,
    MatIconModule,
    MatDialogModule,
    MatGridListModule,
    PrintModule,
  ],
  exports: [DashboardComponent],
  providers: [Location, { provide: LocationStrategy, useClass: PathLocationStrategy }],
})
export class DashboardModule {}
